import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { AppRequests } from '@/context/AppRequests';
import { useServiceToken } from '../auth';

export function useReportChanges() {
  const { getReportChanges } = useContext(AppRequests).MonitoringRequests;
  const tokenResult = useServiceToken('remoulade');

  const changesResult = useQuery({
    queryKey: ['remoulade_report_changes'],
    queryFn: () => getReportChanges(tokenResult.data?.token),

    enabled: tokenResult.isSuccess,
  });

  const isLoading = tokenResult.isLoading || changesResult.isLoading;
  const isError = tokenResult.isError || changesResult.isError;
  const isSuccess = tokenResult.isSuccess && changesResult.isSuccess;
  const isFetching = tokenResult.isFetching && changesResult.isFetching;
  const { data } = changesResult;
  const error = tokenResult.error || changesResult.error;
  return { isLoading, isError, isSuccess, isFetching, data, error };
}
